import React, { FC } from 'react';

import { LEADS_TABLE_COLUMNS } from 'constants/leads';
import { SortingOrder } from 'interfaces';
import { LeadData } from 'interfaces/leads.interfaces';
import Table, { TableSkeleton } from 'shared-components/table';

import LeadsTableItem from './LeadsTableItem';

type Props = {
  leads: LeadData[] | null;
  updateSorting: (column: string, order: SortingOrder) => void;
  loading: boolean;
  rowsNumber: number;
  handleOpenModal: (name: string, reason: string) => void;
};

const LeadsDataTable: FC<Props> = ({ rowsNumber, updateSorting, leads, loading, handleOpenModal }) => {
  if (!leads && !loading) {
    return <div>No leads found</div>;
  }

  return (
    <>
      <Table onUpdateSorting={updateSorting} columns={LEADS_TABLE_COLUMNS}>
        {loading ? (
          <TableSkeleton rowsNumber={rowsNumber} columnsNumber={LEADS_TABLE_COLUMNS.length} />
        ) : (
          leads &&
          leads.map((lead) => (
            <LeadsTableItem
              handleOpenModal={() => handleOpenModal(lead.firstName, lead.reasonForInterest)}
              lead={lead}
              key={lead.id}
            />
          ))
        )}
      </Table>
    </>
  );
};

export default LeadsDataTable;
